import { render, staticRenderFns } from "./adb-tabs.vue?vue&type=template&id=58b23987&"
import script from "./adb-tabs.vue?vue&type=script&lang=ts&"
export * from "./adb-tabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports